import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { formatDistanceToNow } from "../auditUtils";
import JobsListPagination from "../JobsListPagination";
import { getListRangeLabel } from "../aiVisibilityListConstants";
import { isJobReady } from "./writingAssistantUtils";

export default function YourJobsCard({
	jobs,
	loading,
	total,
	page,
	pageSize,
	hasMore,
	onPageChange,
}) {
	const navigate = useNavigate();
	const list = jobs ?? [];

	return (
		<Card className="shadow-sm writing-assistance__your-jobs mt-4">
			<CardHeader className="bg-white border-bottom">
				<h5 className="mb-0">Your jobs</h5>
				<p className="text-muted small mb-0 mt-1">
					{loading
						? "Loading…"
						: `${total || list.length} job${(total || list.length) !== 1 ? "s" : ""} total · ${getListRangeLabel(
								page,
								pageSize,
								total || list.length
						  )}`}
				</p>
			</CardHeader>
			<CardBody>
				{loading ? (
					<div className="text-center py-4">
						<Spinner size="sm" />
					</div>
				) : list.length === 0 ? (
					<p className="text-muted text-center py-3 mb-0">
						No preview jobs yet. Generate a preview above to get started.
					</p>
				) : (
					<>
						<div className="d-flex flex-column gap-3">
							{list.map((job) => {
								const ready = isJobReady(job);

								return (
									<div key={job.id} className="writing-assistance__job-row border rounded p-3">
										<div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-2">
											<div className="d-flex flex-wrap align-items-center gap-2">
												{job.status_label && (
													<span
														className={
															ready
																? "writing-assistance__ready-badge"
																: "writing-assistance__status-badge"
														}
													>
														{ready && <i className="fas fa-check me-1" />}
														{job.status_label}
													</span>
												)}
												{job.created_at && (
													<span className="text-muted small">
														{formatDistanceToNow(job.created_at)}
													</span>
												)}
											</div>
											{ready && (
												<Button
													color="light"
													size="sm"
													className="writing-assistance__view-preview-btn border"
													onClick={() =>
														navigate(
															`/aivisibility/writing-assistance/view?jobId=${encodeURIComponent(job.id)}`
														)
													}
												>
													<i className="far fa-file-alt me-1" />
													View Action Items
												</Button>
											)}
										</div>
										{job.url && (
											<a
												href={job.url}
												target="_blank"
												rel="noopener noreferrer"
												className="writing-assistance__job-url d-block text-break mb-2"
											>
												{job.url}
												<i className="fas fa-external-link-alt ms-1 small" />
											</a>
										)}
										<p className="writing-assistance__job-meta mb-0">
											Audit #{job.audit_id ?? "—"}
											{job.recommendation_id != null && ` · Rec #${job.recommendation_id}`}
											{job.recommendation_name && ` · ${job.recommendation_name}`}
										</p>
									</div>
								);
							})}
						</div>
						<JobsListPagination
							page={page}
							pageSize={pageSize}
							total={total}
							hasMore={hasMore}
							onPageChange={onPageChange}
						/>
					</>
				)}
			</CardBody>
		</Card>
	);
}
